import { useState } from 'react';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { colors } from '../constants/colors';
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider, Tooltip } from "@material-ui/core";

const theme = createTheme({
    root:{
        
    },
    overrides: {
        MuiPickersCalendar: {
            week: {
                '& .MuiPickersDay-current': {
                    color: colors.orange
                },
                '& .MuiPickersDay-daySelected': {
                    backgroundColor: colors.orange,
                    color: colors.white
                }
            }
        }
    },
});

export const DatePicker = (props) => {
    const { label, value, onChange, variant, format, id, inputVariant,
        minDate, tooltip, renderDay, shouldDisableDate } = props;

    // State to manually control tooltip visibility to prevent "sticking"
    const [tipOpen, setTipOpen] = useState(false);

    // Intercept change to force tooltip close immediately upon selection
    const handleChange = (date) => {
        setTipOpen(false);
        if (onChange) {
            onChange(date);
        }
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <ThemeProvider theme={theme}>
              <Tooltip 
                title={tooltip || ""} 
                placement="top" 
                arrow 
                // Manual control: Only open if tooltip text exists AND state is true
                open={!!tooltip && tipOpen}
                disableHoverListener
                disableFocusListener
                disableTouchListener
              >
              <div
                onMouseEnter={() => tooltip && setTipOpen(true)}
                onMouseLeave={() => setTipOpen(false)}
              >
                <KeyboardDatePicker
                    {...props}
                    disableToolbar
                    variant={variant}
                    format={format}
                    id={id}
                    label={label}
                    value={value}
                    onChange={handleChange}
                    inputVariant={inputVariant}
                    fullWidth
                    autoOk
                    minDate={minDate}
                    shouldDisableDate={shouldDisableDate}
                    renderDay={renderDay}
                    onOpen={() => setTipOpen(false)}
                    onClose={() => setTipOpen(false)}                
                    style={{ width: "95%", marginTop:"8px"}}

                />
                </div>
                </Tooltip>
            </ThemeProvider>
        </MuiPickersUtilsProvider>
    );
}

DatePicker.defaultProps = {
    variant: 'inline',
    id:"date-picker-inline",
    format: "dd/MM/yyyy",
    margin:"normal",
    inputVariant:"standard",
    formclass: null
}
export default DatePicker;
